import React from 'react';
import { OrderMarker } from '@/Enums';
import { ModalProps, Nullable } from '@/Types';
import { useLocalization } from '@/Hooks';
import sharedStyles from '../ModalWindows.scss';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { FormSelectInput } from '@/Components/Controls/SelectInput/FormSelectInput';
import { Modal } from '@/Components/Modal/Modal';
import { useChangeOtherStatusesForm } from './hooks/useChangeOtherStatusesForm';
import { useChangeOtherStatusesOptions } from './hooks/useChangeOtherStatusesOptions';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';
import { Label } from '@/Components/Controls/Label/Label';
import styles from './ChangeOtherStatusesModal.scss';

type Props = ModalProps;

type FormData = {
  orderMarker: Nullable<OrderMarker>;
};

export function ChangeOtherStatusesModal({ closeModalWindow }: Props) {
  const {
    buttons,
    modalWindows: { changeOtherStatuses },
    enums: { OrderMarker: OrderMarkerTranslation },
    common: {
      InputPlaceholders: { Select },
    },
  } = useLocalization();

  const { isSalesPage, options, selectedOrders } = useChangeOtherStatusesOptions();

  const { errors, register, setValue, submit, rules } = useChangeOtherStatusesForm(
    selectedOrders,
    closeModalWindow,
    isSalesPage,
  );

  if (!selectedOrders?.length) {
    closeModalWindow();
    return null;
  }

  return (
    <Modal
      onClose={closeModalWindow}
      className={sharedStyles.modalWrapper}
      tourKey={'changeStatusTour'}
      description={{
        title: changeOtherStatuses.Title,
      }}
    >
      <form onSubmit={submit} id={'changeStatus'} className={styles.form}>
        <Label text={OrderMarkerTranslation.Placeholder} />
        <FormSelectInput<FormData>
          name={'orderMarker'}
          options={[{ key: '', value: Select }, ...options]}
          error={errors}
          setValue={setValue}
          register={register}
          rules={{ ...rules.required }}
        />

        <ButtonsWrapper>
          <Button
            text={buttons.Cancel}
            theme={BUTTON_THEMES.SUCCESS_TRANSPARENT}
            onClick={closeModalWindow}
            type={'button'}
          />
          <Button autoFocus={true} text={buttons.Change} theme={BUTTON_THEMES.SUCCESS} type={'submit'} />
        </ButtonsWrapper>
      </form>
    </Modal>
  );
}
